<template>
  <div class="main-content">
    <form action="" @submit.prevent="saveDrug">
      <div class="row">
        <div class="col-md-6">
          <div class="card">
            <div class="card-body">
              <Priority :drug="drug"/>
              <div class="form-group mt-1">
                <label for="">Название на платформе</label>
                <input required class="form-control" type="text" v-model="drug.title"/>
              </div>
              <div class="form-group">
                <label for="">Название на английском</label>
                <input class="form-control" type="text" v-model="drug.en_title"/>
              </div>
              <div class="form-group">
                <label for="">Предложенное ЧПУ</label>
                <input class="form-control" type="text" v-model="drug.slug"/>
              </div>
              <div>
                <Recipe :detail="details.recipe[0]"/>
              </div>
              <div>
                <template v-if="details.egk">
                  <EgkSelect ref="egkCodes" :details="details.egk" :updateDetail="(d) => this.details.egk = d"/>
                </template>
              </div>
              <div class="input-group">
                <select class="form-control" v-model="drug.income_country_id" @change="updateCostPrice">
                  <option v-for="country in $AllCountries" :value="country.id">{{ country.name }} /
                    {{ $AllCurrencies[country.currency_id].currency }}
                  </option>
                </select>
                <input required type="text" v-model="buyPrice" placeholder="Закупка" @change="updateCostPrice"
                       class="form-control">
                <div class="input-group-prepend">
                  <span class="input-group-text"><strong>€ {{ costPrice }}</strong></span>
                </div>
              </div>
              <Registration :drug="drug" :detail="details.registration[0]"/>
            </div>
          </div>
          <div class="card">
            <div class="card-body">
              <p>Дополнительная страна закупки</p>
              <SupplyCountries
                :drug="drug"
                :details="details.extra.country"
              />
            </div>
          </div>
          <div class="card">
            <div class="card-body">
              <SelectCombineDrugs
                ref="combineDrugs"
                :drugIsCombined="false"
              />
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="card">
            <div class="card-body">
              <div class="form-group">
                <label for="">Производитель</label>
                <input class="form-control" type="text" v-model="details.manufacturer[0].title.value"/>
              </div>
              <div class="form-group">
                <label for="">Страна производитель</label>
                <input class="form-control" type="text" v-model="details.manufacturer[0].country.value"/>
              </div>
              <div class="form-group">
                <label for="">Действующее вещество</label>
                <input class="form-control" type="text" v-model="drug.substance"/>
              </div>
              <div class="form-group">
                <label for="">Форма выпуска</label>
                <input class="form-control" type="text" v-model="drug.release_form"/>
              </div>
              <div class="form-group">
                <label for="">Препарат (для текста АВД)</label>
                <input class="form-control" type="text" v-model="drug.drug"/>
              </div>
              <div class="form-group">
                <label for="">В упаковке</label>
                <input class="form-control" type="text" v-model="drug.in_set"/>
              </div>
              <div class="form-group">
                <label for="">Рецептурность</label>
                <select v-model='drug.site_prescription' class="form-control">
                  <option value="1">По рецепту</option>
                  <option value="2">Без рецепта</option>
                </select>
              </div>
              <div class="form-group">
                <label for="">Код PZN</label>
                <input class="form-control" type="text" v-model="details.manufacturer[0].pzn.value"/>
              </div>
              <label for="">Фасовка</label>
              <div class="input-group">
                <input class="form-control" type="number" v-model="drug.packaging"/>
                <div class="input-group-append">
                  <span class="input-group-text">комплектность:</span>
                  <input required class="form-control" type="number" @change="updateCostPrice" v-model="drug.pack_set"/>
                </div>
              </div>
              <div class="form-group mt-1">
                <label for="">Рубрика</label>
                <select class="form-control" v-model="category">
                  <option value="0" disable>Укажите рубрику</option>
                  <option v-for="cat in categories" :value="cat.id">{{ cat.name }}</option>
                </select>
              </div>
              <label for="ch11">Регулярный прием (кол. дней)</label>
              <div class="input-group">
                <div class="input-group-prepend">
                  <div class="input-group-text">
                    <input id="ch11" type="checkbox" v-model="details.regular_reception[0].use.value">
                  </div>
                </div>
                <input v-model="details.regular_reception[0].days.value" type="number" class="form-control">
              </div>
              <div>
                <label for="">Цены от количества</label>
                <DiffPrices
                  :prices="prices"
                  :singlePrice="true"
                  :updateRecords="(r) => {this.prices = r}"
                />
              </div>
              <div class="form-group">
                <div class="form-check">
                  <input type="checkbox"
                         v-model="selectedNoSiteProjects[7].selected" class="form-check-input"
                         id="ch__1">
                  <label class="form-check-label" for="ch__1">Создать на АнУ</label>
                </div>
                <div v-if="selectedNoSiteProjects[7].selected">
                  <label for="">Цены на проекте</label>
                  <DiffPrices
                    :prices="selectedNoSiteProjects[7].prices"
                    :updateRecords="(r) => {this.selectedNoSiteProjects[7].prices = r}"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="card">
        <div class="card-body">
          <p>Укажите сайты на которых необходимо создать препарат</p>
          <div class="btn-group btn-group-toggle flex mb-2" data-toggle="buttons">
            <template v-for="project in selectedProjects">
              <label v-bind:class="{'btn btn-outline-success mr-1': true, 'active':project.selected}">
                <input @change="() => updateSelectedProjects(project.id)" type="checkbox" v-model="project.selected">
                {{ project.title }}
              </label>
            </template>
          </div>
          <div class="row">
            <div class="col-md-6">
              <div class="form-group">
                <label for="">Ключевые слова ( разделитель - запятая )</label>
                <textarea class="form-control" v-model='drug.keywords' rows="2"></textarea>
              </div>
              <div class="form-group">
                <label for="">Комментарии по упаковке</label>
                <textarea class="form-control" v-model='drug.pack_box_comment' rows="2"></textarea>
              </div>
<!--              <div class="form-group">-->
<!--                <label for="">Комментарий по выкладке на складах</label>-->
<!--                <textarea class="form-control" v-model='drug.pack_comment' rows="2"></textarea>-->
<!--              </div>-->
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label for="">Главный ключевик (разделитель - запятая)</label>
                <textarea class="form-control" v-model='drug.main_keywords' rows="2"></textarea>
              </div>
              <!--              <div class="form-group">-->
              <!--                <label for="">Примечание</label>-->
              <!--                <textarea class="form-control" v-model='drug.internal_comments' rows="2"></textarea>-->
              <!--              </div>-->
            </div>
          </div>
          <div class="text-right">
            <LoadingButton
              title="Создать препарат"
              className="btn btn-success"
              type="submit"
              :onClick="() => {}"
              :loading="btnLoading"
              color="white"
            />
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>

import api from '@/api'
import Priority from './components/details/Priority'
import Recipe from './components/details/Recipe'
import EgkSelect from './components/details/EgkSelect'
import Registration from './components/details/Registration'
import LoadingButton from "@/components/buttons/LoadingButton";
import DiffPrices from "@/views/nomenclature/components/DiffPrices";
import DrugSearchNew from "@/components/drugs/DrugSearchNew.vue";
import SelectCombineDrugs from "@/views/nomenclature/components/SelectCombineDrugs.vue";
import SupplyCountries from "@/views/nomenclature/components/details/SupplyCountries.vue";

export default {
  components: {
    SupplyCountries,
    SelectCombineDrugs,
    DrugSearchNew,
    Priority,
    Recipe,
    EgkSelect,
    Registration,
    LoadingButton,
    DiffPrices,
  },
  computed: {
    $AllCountries() {
      return this.$store.getters['platform/countries'];
    },
    $AllCurrencies() {
      return this.$store.getters['platform/currencies']
    },
    $AllProjects() {
      return this.$store.getters['platform/projects']
    },

  },
  data() {
    return {
      marginCalculationPreset: null,
      btnLoading: false,
      costPrice: 0,
      buyPrice: null,
      category: 0,
      categories: [],
      selectedProjects: {},
      selectedNoSiteProjects: {
        7: {
          id: 7,
          selected: false,
          prices: [{
            qty: 1,
            price: 0,
            site_id: 7,
            margin: 0
          }]
        }
      },
      prices: [{
        qty: 1,
        price: 0,
        site_id: 1,
        margin: 0
      }],
      drugPackType: null,
      drug: {
        priority: null,
        title: null,
        slug: null,
        en_title: null,
        income_currency_id: 29,
        income_country_id: 1,
        substance: null,
        pack_set: 1,
        packaging: null,
        cool: 0,
        is_press_can: 0,
        site_prescription: 1,
        lgot_price: 0,
        keywords: null,
        main_keywords: null,
      },
      details: {
        egk: [],
        extra: {
          country: [],
        },
        recipe: [{
          no_use: {value: 1, type: 'int'},
          lt_title: {value: null, type: 'text'},
          signa: {value: null, type: 'text'},
          pack: {value: null, type: 'int'},
          days: {value: null, type: 'int'}
        }],
        manufacturer: [{
          title: {value: null, type: 'text'},
          country: {value: null, type: 'text'},
          barcode: {value: null, type: 'text'},
          pzn: {value: null, type: 'text'}
        }],
        regular_reception: [{
          use: {value: false, type: 'int'},
          days: {value: null, type: 'int'},
        }],
        registration: [{
          use: {value: 0, type: 'int'},
          type: {value: 0, type: 'int'},
          date: {value: null, type: 'text'},
        }]
      }
    }
  },
  watch: {
    'prices': {
      handler: function (val) {
        this.updateCostPrice();
      },
      deep: true
    },
    'selectedNoSiteProjects': {
      handler: function (val) {
        this.updateCostPrice();
      },
      deep: true
    },
  },
  created() {
    this.getSiteCategories();
    const marginCalculationPreset = this.$UserDetails.find((d) => d.alias === 'margin_calculation_preset');
    this.marginCalculationPreset = marginCalculationPreset && marginCalculationPreset.details && marginCalculationPreset.details[0];
  },
  methods: {
    updateSelectedProjects(projectId) {
      switch (+projectId) {
        case 13:
          if (this.selectedProjects[projectId].selected) {
            // this.selectedProjects[3].selected = true;
          }
          break;
        case 3:
          if (!this.selectedProjects[projectId].selected) {
            // this.selectedProjects[12].selected = false;
            // this.selectedProjects[13].selected = false;
          }
          break;
      }
    },
    async saveDrug() {
      const noValid = this.validateDrug();
      if (noValid.length) {
        toastr['warning'](noValid.join("\n"));
        return;
      }
      this.btnLoading = true;
      await this.$refs.egkCodes.updateAllCodes();
      const selectedProjects = Object.values(this.selectedProjects).reduce((acc, p) => {
        if (p.selected) acc.push(+p.id);
        return acc;
      }, []);
      if (this.selectedNoSiteProjects[7]?.selected) {
        selectedProjects.push(7);
      }
      if (selectedProjects.includes(12)) selectedProjects.push(13);
      selectedProjects.push(4);
      const {data} = await api.post('/new/nomenclature/new', {
        drug: {...this.drug, combined_type: +this.$refs.combineDrugs.combineType},
        details: this.details,
        combinedList: this.$refs.combineDrugs.combinedList.map((d) => {
          return {drug_id: d.drug_id, rate: d.rate}
        }),
        prices: this.prices,
        category: this.category,
        noSitePrices: Object.values(this.selectedNoSiteProjects).reduce((acc, p) => {
          if (p.selected) {
            acc = [...acc, ...p.prices];
          }
          return acc;
        }, []),
        selectedProjects,
      })
      if (data.success) {
        toastr['success'](data.message || 'Сохранено');
      } else {
        toastr['warning'](data.message || 'Ошибка сохранения');
      }
      this.btnLoading = false;
    },
    validateDrug() {
      let error = [];
      if (!this.drug.priority) {
        error.push('Не указан приоритет')
      }
      ([
        ...this.prices,
        ...(this.selectedNoSiteProjects[7].selected && this.selectedNoSiteProjects[7].prices || [])
      ]).forEach((p) => {
        if (p.price <= 0) {
          error.push('Не валидная цена на количество!');
        }
      })

      if (!this.category) {
        error.push('Не указана категория');
      }
      if (!this.drug.pack_set || this.drug.pack_set <= 0) {
        error.push('Не верно указана комплектность');
      }
      this.details.recipe.forEach((r) => {
        if (!r.no_use.value) {
          if (!r.lt_title.value
            || !r.signa.value
            || !r.days.value
            || r.days.value < 0
            || !r.pack.value
            || r.pack.value < 0
          ) {
            error.push('Неверные данные для рецепта');
          }
        }
      })
      return error;
    },
    async getSiteCategories() {
      const {data} = await api.index('projects/categories');
      if (data.success) {
        this.categories = data.records;
      }
      this.selectedProjects = this.$AllProjects.reduce((acc, p) => {
        if (p.is_active && ![1, 4, 7, 13].includes(p.id)) {
          acc[p.id] = {
            id: p.id,
            title: p.title,
            order_num: p.order_num,
            selected: true
          }
        }
        return acc;
      }, {});
    },
    updateCostPrice() {
      this.costPrice = 0;
      const country = this.$AllCountries.find((c) => c.id === +this.drug.income_country_id);
      this.drug.income_currency_id = country.currency_id;
      if (this.buyPrice) {
        this.costPrice = Math.round(+this.buyPrice * this.$AllCurrencies[this.drug.income_currency_id].rate * 100) / 100;
        this.drug.projected_price = this.costPrice;
        this.drug.income_country_price = this.buyPrice;
      }

      const fullPrice = this.costPrice * +this.drug.pack_set;
      let recommendedPrice = fullPrice + Math.round(fullPrice * this.marginCalculationPreset.baseMargin / 100);
      recommendedPrice += Math.round(recommendedPrice * this.marginCalculationPreset.deliveryPercent / 100);
      recommendedPrice = Math.round(recommendedPrice * this.marginCalculationPreset.calculatedRate) + this.marginCalculationPreset.delivery;
      this.prices.forEach((p, i) => {
        this.prices[i] = this.updateSetPriceMargin(p, recommendedPrice);
      })
      this.prices.forEach((p, i) => {
        this.prices[i] = this.updateSetPriceMargin(p, recommendedPrice);
      })
      Object.keys(this.selectedNoSiteProjects).forEach((projectId) => {
        this.selectedNoSiteProjects[projectId].prices.forEach((p, i) => {
          this.selectedNoSiteProjects[projectId].prices[i] = this.updateSetPriceMargin(p, recommendedPrice);
        })
      })
    },
    updateSetPriceMargin(p, recommendedPrice) {
      if (+this.costPrice) {
        if (!(+p.price)) {
          p.price = recommendedPrice;
        }
        p.margin = this.mixinGetProfitFigures({
          price: p.price,
          costPrice: this.costPrice,
          pack_set: +this.drug.pack_set
        }, this.marginCalculationPreset);
      }
      return p;
    }
  }
}

</script>

<style scoped>
.form-group {
  margin-bottom: 3px;
}

textarea {
  font-size: 13px;
}

.col-md-6 {
  padding-right: 1px;
  padding-left: 1px;
}

.btn i {
  text-align: center;
}
</style>
